import { Button, Dialog } from '@tomo/ui';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useStore } from '../../lib/store.ts';
import { newProjectOpen } from '../shell/ui-state.ts';
import { NewProjectFields, useNewProjectForm } from './NewProjectForm.tsx';

/** Opened from the project menu or the command palette (`openNewProject`). */
export function NewProjectDialog() {
  const open = useStore(newProjectOpen);
  const close = () => newProjectOpen.set(false);
  const navigate = useNavigate();
  const form = useNewProjectForm((id) => {
    close();
    navigate(`/p/${id}`);
  });

  // Every opening starts from a blank form.
  useEffect(() => {
    if (open) form.reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <Dialog
      open={open}
      onOpenChange={(next) => newProjectOpen.set(next)}
      title="New project"
      description="Name your game, then list what it’s made of."
      size="lg"
      footer={
        <>
          <Button variant="ghost" onClick={close}>
            Cancel
          </Button>
          <Button variant="primary" onClick={form.submit} loading={form.busy} disabled={!form.name.trim()} shortcut="mod+enter">
            Create project
          </Button>
        </>
      }
    >
      <NewProjectFields form={form} />
    </Dialog>
  );
}
